export const INCOMPLETE_SELL_INVOICE =
  'We have received your buy order. Your order will be processed shortly and you will receive an invoice on your registered email address.';
export const INCOMPLETE_BUYBACK_INVOICE =
  'We have received your sell request. Your order will be processed shortly and you will receive an purchase memo on your registered email address.';
export const PAYMENT_PENDING_MESSAGE =
  'Your order will be processed shortly after we confirm the payment status.';
export const BUYBACK_INVOICE_UPLOAD_MESSAGE =
  'Please click on the link sent to your registered email to upload your GST invoice and proceed further.';
export const BUYBACK_INVOICE_APPROVAL_MESSAGE =
  'Your invoice is under review and will be approved within 48 working hours.';
export const OTP_VERIFY_SUCCESS = 'OTP verified successfully';
export const OTP_VERIFY_FAILURE = 'OTP verification failed';
export const ACK_SUCCESS = 'success';
export const ACK_FAIL = 'fail';
export const SIGNUP_SUCCESS = 'User account has been created.';
export const OTP_SENT_TO_MESSAGE =
  'Please enter the OTP sent to the mobile number ending with XXXXXX{suffixDigits}';
export const OTP_SENT_TO_EMAIL =
  'Please enter the OTP sent to your email address';
export const OTP_SENT_TO_MOBILE =
  'Please enter the OTP sent to your mobile number';
export const OTP_SENT_TO_REG_MESSAGE =
  'Please enter the OTP sent to your registered mobile number ending with XXXXXX{suffixDigits} / registered email address';
export const FORGOT_RESET_MESSAGE =
  'Please enter the OTP sent to your registered mobile number {mobile}';
export const AADHAAR_OTP_SENT =
  'Please enter the OTP sent to your mobile number linked with Aadhaar';
export const BANK_TRANSFER_APPROVAL_PENDING =
  'Money will be credited to your bank account within 1 or 2 working days.';
export const IDLE_TIMEOUT = 1000 * 60 * 10;
export const IDLE_PROMPT_TIMEOUT = 1000 * 30;
export const TRADEMARK_LOGO_URL =
  'https://ebullion-assets.s3.ap-south-1.amazonaws.com/logo.jpg';
